import angular from 'angular';

class ModalAddKissUserAuthorizationCtrl {
    /* @ngInject */
    constructor($translate, LegalEntityGroupUser, invitedEntitySvc, logger, InvBuyerRelationFilter) {
        this.$translate = $translate;
        this.LegalEntityGroupUser = LegalEntityGroupUser;
        this.InvBuyerRelationFilter = InvBuyerRelationFilter;
        this.invitedEntitySvc = invitedEntitySvc;
        this.logger = logger;
    }

    $onInit() {
        const ctrl = this;
        ctrl.selectedProfile = null;
        ctrl.authorization = new this.LegalEntityGroupUser();
        ctrl.legalEntityGroups = this.resolve.groups;
        if (ctrl.legalEntityGroups.length === 1) {
            ctrl.authorization.legalEntityGroup = ctrl.legalEntityGroups[0];
        }
        ctrl.currentProfiles = this.resolve.profiles;
        ctrl.wrkFlwProfiles = this.resolve.wkfProfiles;
        ctrl.profilesToSelect = this.getProfilesToSelect();
    }

    getProfilesToSelect() {
        const profilesToSelect = [];
        //si l'utilisateur a le profil admin alors on ne peut pas lui proposer le profil responsable
        if (!this.currentProfiles.find(p => p.role === 'ADMIN_FO'))
            profilesToSelect.push({
                role: 'ACCOUNTANT',
                label: this.$translate.instant('kiss_user.profil.accountant'),
            });

        if (this.isProfilBuyerInvited()) {
            profilesToSelect.push({
                role: 'EXECUTIVE_INVBUY',
                label: this.$translate.instant('kiss_user.profil.executive_invbuy'),
            });

            this.hasCommandServiceEnabled().then(enabled => {
                if (enabled) {
                    profilesToSelect.push({
                        role: 'PURCHASING_MANAGER',
                        label: this.$translate.instant('kiss_user.profil.purchasing_manager'),
                    })
                }
            });

            if (this.isDocumentarySpace()) {
                profilesToSelect.push({
                    role: 'ADMIN_GED',
                    label: this.$translate.instant('kiss_user.profil.admin_ged'),
                });
                profilesToSelect.push({
                    role: 'USER_GED',
                    label: this.$translate.instant('kiss_user.profil.user_ged'),
                });
            }
        }

        if (this.isProfilSellerInvited()) {
            profilesToSelect.push({
                role: 'EXECUTIVE',
                label: this.$translate.instant('kiss_user.profil.executive'),
            });
        }

        if (this.wrkFlwProfiles && this.wrkFlwProfiles.length > 0) {
            this.wrkFlwProfiles.forEach(p => {
                p.role = 'USER_WKF';
                profilesToSelect.push(p);
            });
        }

        return profilesToSelect;
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }

    confirm() {
        if (!this.authorization.legalEntityGroup) {
            this.logger.error(this.$translate.instant('error.missing_authorisation_group'));
            return;
        }
        if (!this.selectedProfile) {
            this.logger.error(this.$translate.instant('error.missing_authorisation_role'));
            return;
        }

        this.authorization.role = this.selectedProfile.role;
        this.authorization.wkfProfile = this.selectedProfile.code;
        this.authorization.wkfScope = this.selectedProfile.workflowScope;
        this.authorization.type = this.selectedProfile.type;
        this.modalInstance.close(this.authorization);
    }

    onProfileChange() {
        if (['ACCOUNTANT', 'ADMIN_GED'].some(role => this.isRoleSelected(role))) {
            this.legalEntityGroups = this.legalEntityGroups.filter(lgr => lgr.type === 'INVITED_SELLER');
            this.authorization.legalEntityGroup = this.legalEntityGroups[0];
        } else {
            this.legalEntityGroups = this.resolve.groups;
        }
    }

    isRoleSelected(role) {
        return this.authorization.role && this.authorization.role === role;
    }

    isProfilBuyerInvited() {
        return this.resolve.principal.detail.profilBuyerInvited;
    }

    isProfilSellerInvited() {
        return this.resolve.principal.detail.profilSellerInvited;
    }

    isDocumentarySpace() {
        return this.resolve.legalEntity.hasDocumentarySpace;
    }

    hasCommandServiceEnabled() {
        const filter = new this.InvBuyerRelationFilter({
            enabledService: 'ORDER'
        });
        return this.invitedEntitySvc.searchInvBuyerRelations(this.resolve.legalEntity.id, filter).then(
            relations => relations.length !== 0,
            (error) => {
                this.logger.error(error);
                return false;
            }
        );
    }
}

angular.module('app.kissuser').component('modalAddKissUserAuthorization', {
    templateUrl: require('./modal-add-user-authorization.html'),
    controller: ModalAddKissUserAuthorizationCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
